import {DomainEvent} from './DomainEvent';
import {Gallery} from '../resources/Gallery';

export class GalleryDeleted extends DomainEvent<Gallery> {}
